<main class="main">
    <div class="main-wrapper">
      <section class="padding-first about1" id="about_us">
        <div class="container">
  
          <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
            <div class="icon-back">
              <span>Back</span>
            </div>
          </a>
  
  
          <div>
            <div class="bl-rows">
              <div class="text">
                <h2>Gennius XYZ is excited to announce the appointment of Akshay Chopra as Chief Commercial Officer, effective immediately.</h2>
  
                <span>By Gennius January 16, 2025</span>
              </div>
              <div class="img">
                <img src="./assets/img/gennius/bg-inside-notice14.webp">
              </div>
            </div>
          </div>
  
          <div class="bl-center">
  
            <p><strong>Dubai UAE - Gennius XYZ</strong>, Akshay brings a wealth of expertise in the fintech and payments industry, with nearly 20 years of leadership experience in developing innovative strategies, launching transformative products, and driving market growth across diverse regions, including the Middle East, Africa, and Asia-Pacific. As co-founder of 237 Ventures, Akshay serves as an investor and board member at leading global fintech and Web3 ventures. He also serves as Payments Chair for the MENA FinTech Association and holds 7 patents in payments technologies. Akshay was formerly VP of Innovation for CEMEA at Visa (based in Singapore and Dubai), where he led several groundbreaking initiatives in digital payments, financial inclusion, and strategic partnerships.  
            </p>
  
            <p>In his role at <strong>Gennius XYZ</strong>, Akshay will lead the company’s strategic expansion into new geographies and verticals, with a sharp focus on forging strategic partnerships. His deep industry knowledge and proven track record of innovation will accelerate <strong>Gennius XYZ’s</strong> mission of reshaping digital engagement as a key driver of revenue growth.</p>
  
            <p><strong>Gennius XYZ</strong> is a global player in digital engagement technology and digital loyalty solutions, leveraging technology to accelerate revenues in customer engagement. The company’s flagship offering, the One Platform, integrates AI, Web3, and cryptocurrency capabilities into a unified super app, enabling businesses to create seamless, personalized experiences. With features like AI-driven concierge services, a global marketplace, and modular rewards solutions, <strong>Gennius XYZ</strong> empowers businesses and consumers to connect, engage, and thrive in a digital-first economy.
            </p>
  
            <p>Akshay’s appointment signals <strong>Gennius XYZ’s</strong> commitment to scaling its innovative solutions globally and advancing its vision of transforming the digital rewards ecosystem. We are thrilled to welcome him to the team and look forward to his leadership in driving <strong>Gennius XYZ’s</strong> next phase of growth. 
            </p>

            <p>For more information about <strong>Gennius XYZ</strong>, please visit <a
                href="https://gennius.xyz/"><strong>www.gennius.xyz</strong></a>.</p>
  
  
          </div>
  
        </div>
      </section>
  
  
    </div>
  </main>
  <app-footer></app-footer>